import {
  useSearchQueryFilter,
  useSearchTypeFromRoute,
} from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useCallback } from 'react';
import { SearchFilter } from '../../types';
import {
  ClearButtonType,
  ClearTagsButton,
} from '../filter-tags/components/clear-tags-button';
import { useFilterTags } from '../filter-tags/hooks/use-filter-tags';
import { buildClearAllDraft, getFilterFields } from '../filter-tags/utils';
import { FilterTagsHalfClosedTagList } from './components/filter-tags-half-closed-tag-list';
import * as Styled from './styles';
import * as SX from './sx';
import type { FilterTagsHalfClosedProps as Props } from './types';

export const FilterTagsHalfClosed = memo(
  ({ className, filter, visible }: Props) => {
    const type = useSearchTypeFromRoute();
    const { params, setParams } = useSearchQueryFilter({
      select: getFilterFields(filter),
    });
    const tags = useFilterTags(params, filter as SearchFilter);

    const handleClear = useCallback(() => {
      const draft = buildClearAllDraft(tags);
      setParams(draft);
    }, [tags, setParams]);

    if (!visible) return null;
    if (tags.empty) return null;

    return (
      <Styled.Wrapper
        className={classnames('FilterTagsHalfClosed', className)}
        sx={SX.root}
      >
        {visible && (
          <>
            <Box sx={SX.box}>
              <FilterTagsHalfClosedTagList tags={tags} />
            </Box>
            <Box sx={SX.box}>
              <ClearTagsButton
                type={ClearButtonType.ICON_BUTTON}
                onClick={handleClear}
              />
            </Box>
          </>
        )}
      </Styled.Wrapper>
    );
  }
);

FilterTagsHalfClosed.displayName = 'FilterTagsHalfClosed';
